import { render, staticRenderFns } from "./subcategoryDetails.vue?vue&type=template&id=7f7403e6&"
import script from "./subcategoryDetails.vue?vue&type=script&lang=js&"
export * from "./subcategoryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports